type UsuarioComPerfil = {
  roleGroup?: {
    id?: string
  }
  role_group?: {
    id?: string
  }
}

export function dividirEmLotes<T> (itens: T[], tamanhoDoLote: number): T[][] {
  if (tamanhoDoLote <= 0) throw new Error('O tamanho do lote deve ser maior que zero')

  const lotes: T[][] = []
  for (let indice = 0; indice < itens.length; indice += tamanhoDoLote) {
    lotes.push(itens.slice(indice, indice + tamanhoDoLote))
  }
  return lotes
}

export function obterIdDoPerfilDoUsuario (usuario: UsuarioComPerfil): string | undefined {
  return usuario.roleGroup?.id || usuario.role_group?.id
}

export function obterUsuariosParaSincronizarComBloqueioPorPerfil (
  usuariosIds: string[],
  naoEnviarEmails: boolean
): string[] {
  return naoEnviarEmails ? usuariosIds : []
}
